import { useEffect } from 'react';

type UseAdvancedTimelineKeyboardArgs = {
  canEdit: boolean;
  onEscape: () => void;
  onSplit: () => void;
  onUndo: () => void;
  onRedo: () => void;
  onDelete: () => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
};

export const useAdvancedTimelineKeyboard = ({
  canEdit,
  onEscape,
  onSplit,
  onUndo,
  onRedo,
  onDelete,
  onZoomIn,
  onZoomOut,
}: UseAdvancedTimelineKeyboardArgs) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement | null;
      const isEditableTarget =
        target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        target?.isContentEditable;

      if (isEditableTarget) {
        return;
      }

      if (event.key === 'Escape') {
        onEscape();
        return;
      }

      if (
        (event.key === 's' || event.key === 'S') &&
        !event.metaKey &&
        !event.ctrlKey
      ) {
        event.preventDefault();
        if (canEdit) {
          onSplit();
        }
        return;
      }

      if (
        (event.metaKey || event.ctrlKey) &&
        event.key === 'z' &&
        !event.shiftKey
      ) {
        event.preventDefault();
        onUndo();
        return;
      }

      if (
        ((event.metaKey || event.ctrlKey) &&
          event.shiftKey &&
          event.key === 'z') ||
        ((event.metaKey || event.ctrlKey) && event.key === 'y')
      ) {
        event.preventDefault();
        onRedo();
        return;
      }

      if (event.key === 'Delete' || event.key === 'Backspace') {
        event.preventDefault();
        onDelete();
        return;
      }

      if (event.key === '+' || event.key === '=') {
        event.preventDefault();
        onZoomIn();
        return;
      }

      if (event.key === '-') {
        event.preventDefault();
        onZoomOut();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [
    canEdit,
    onDelete,
    onEscape,
    onRedo,
    onSplit,
    onUndo,
    onZoomIn,
    onZoomOut,
  ]);
};
